{
  "lifecycle.title": "Joiners & leavers",
  "lifecycle.kind.onboarding": "Onboarding",
  "lifecycle.kind.offboarding": "Offboarding",
  "lifecycle.owner.hr": "HR",
  "lifecycle.owner.manager": "Manager",
  "lifecycle.owner.employee": "Employee",
  "lifecycle.owner.it": "IT",
  "lifecycle.due.overdue": "Was due {date}",
  "lifecycle.due.today": "Due today",
  "lifecycle.due.upcoming": "Due {date}",
  "lifecycle.offset.onboarding.before": "{days, plural, one {# day} other {# days}} before the first day",
  "lifecycle.offset.onboarding.on": "On the first day",
  "lifecycle.offset.onboarding.after": "{days, plural, one {# day} other {# days}} after the first day",
  "lifecycle.offset.offboarding.before": "{days, plural, one {# day} other {# days}} before the last day",
  "lifecycle.offset.offboarding.on": "On the last day",
  "lifecycle.offset.offboarding.after": "{days, plural, one {# day} other {# days}} after the last day",
  "lifecycle.startsOn.onboarding": "First day: {date}",
  "lifecycle.startsOn.offboarding": "Last day: {date}",
  "lifecycle.item.doneBy": "Done by {name} · {when}",
  "lifecycle.item.doneAt": "Done · {when}",
  "lifecycle.items.label": "Tasks of {name}",
  "lifecycle.progress.done": "{done} of {total} done",
  "lifecycle.progress.overdue": "{count} overdue",
  "lifecycle.tick.conflict": "Someone else ticked this task in the meantime. The checklist now shows their change.",
  "lifecycle.links.checklists": "Joiners and leavers views",
  "lifecycle.links.letters": "Letter views",
  "lifecycle.links.open": "Open checklists",
  "lifecycle.links.requests": "Requests",
  "lifecycle.links.templates": "Templates",
  "lifecycle.board.title": "Joiners & leavers",
  "lifecycle.board.description": "Every onboarding and offboarding checklist with tasks left. Open one to tick its tasks.",
  "lifecycle.board.column.onboarding": "Joining",
  "lifecycle.board.column.offboarding": "Leaving",
  "lifecycle.board.columnEmpty.onboarding": "Nobody is joining right now.",
  "lifecycle.board.columnEmpty.offboarding": "Nobody is leaving right now.",
  "lifecycle.board.day.onboarding": "First day",
  "lifecycle.board.day.offboarding": "Last day",
  "lifecycle.board.open": "Open {title} for {name}",
  "lifecycle.board.openProfile": "Open their profile",
  "lifecycle.board.unknownPerson": "Former colleague",
  "lifecycle.board.loadError": "We could not load the checklists",
  "lifecycle.board.empty.title": "No one is joining or leaving",
  "lifecycle.board.empty.body": "When someone joins or leaves, start a checklist for them. It shows here until every task is done.",
  "lifecycle.board.toDirectory": "Go to the directory",
  "lifecycle.start.open": "Start a checklist",
  "lifecycle.start.title": "Start a checklist",
  "lifecycle.start.titleFor": "Start a checklist for {name}",
  "lifecycle.start.template": "Template",
  "lifecycle.start.date.onboarding": "First working day",
  "lifecycle.start.date.offboarding": "Last working day",
  "lifecycle.start.dateHint.onboarding": "Task dates count from this day. It starts at the hire date.",
  "lifecycle.start.dateHint.offboarding": "Task dates count from this day. It starts at the last day on the record.",
  "lifecycle.start.preview": "{count, plural, one {# task} other {# tasks}} will be created",
  "lifecycle.start.previewLabel": "Tasks and their due dates",
  "lifecycle.start.submit": "Start the checklist",
  "lifecycle.start.started": "Checklist started for {name}.",
  "lifecycle.start.noTemplates": "There is no checklist template on offer yet.",
  "lifecycle.start.toTemplates": "Make one",
  "lifecycle.pick.description": "Choose whom it is for. Their profile opens with the checklist ready to start.",
  "lifecycle.pick.person": "Employee",
  "lifecycle.pick.placeholder": "Choose a person",
  "lifecycle.pick.search": "Search by name, email or code",
  "lifecycle.pick.empty": "No one matches.",
  "lifecycle.pick.continue": "Continue",
  "lifecycle.checklists.title": "Checklists",
  "lifecycle.checklists.description": "Onboarding and offboarding tasks for {name}.",
  "lifecycle.checklists.loadError": "We could not load the checklists",
  "lifecycle.checklists.empty.title": "No checklists yet",
  "lifecycle.checklists.empty.body": "Start an onboarding checklist when {name} joins, or an offboarding one when they leave.",
  "lifecycle.checklists.empty.readOnly": "HR has not started a checklist for {name}.",
  "lifecycle.templates.title": "Checklist templates",
  "lifecycle.templates.description": "The tasks every joiner or leaver gets, who does each one and when it is due.",
  "lifecycle.templates.new": "New template",
  "lifecycle.templates.loadError": "We could not load the templates",
  "lifecycle.templates.empty.title": "No templates yet",
  "lifecycle.templates.empty.body": "Write the steps of welcoming someone, or seeing them off, once. Then start them for each person in a click.",
  "lifecycle.templates.group.onboarding": "Onboarding",
  "lifecycle.templates.group.offboarding": "Offboarding",
  "lifecycle.templates.taskCount": "{count, plural, one {# task} other {# tasks}}",
  "lifecycle.templates.retired": "Not offered",
  "lifecycle.templates.showTasks": "Show the tasks",
  "lifecycle.templates.edit": "Edit",
  "lifecycle.templates.editNamed": "Edit {name}",
  "lifecycle.editor.newTitle": "New checklist template",
  "lifecycle.editor.editTitle": "Edit checklist template",
  "lifecycle.editor.name": "Name",
  "lifecycle.editor.namePlaceholder": "Welcome a new joiner",
  "lifecycle.editor.nameMissing": "Give the template a name.",
  "lifecycle.editor.kind": "Kind",
  "lifecycle.editor.kindHint.onboarding": "Dates count from the first day",
  "lifecycle.editor.kindHint.offboarding": "Dates count from the last day",
  "lifecycle.editor.active": "Offer it when starting a checklist",
  "lifecycle.editor.activeHint": "Checklists already started keep their tasks either way.",
  "lifecycle.editor.tasks": "Tasks",
  "lifecycle.editor.tasksHint.onboarding": "In order. Each one is due a number of days from the first day.",
  "lifecycle.editor.tasksHint.offboarding": "In order. Each one is due a number of days from the last day.",
  "lifecycle.editor.noTasks": "Add at least one task.",
  "lifecycle.editor.titleLabel": "Task {number}: what to do",
  "lifecycle.editor.titlePlaceholder": "Prepare the laptop and accounts",
  "lifecycle.editor.titleMissing": "Say what the task is.",
  "lifecycle.editor.ownerLabel": "Task {number}: who does it",
  "lifecycle.editor.daysLabel": "Task {number}: days",
  "lifecycle.editor.relationLabel": "Task {number}: when",
  "lifecycle.editor.days": "{count, plural, one {day} other {days}}",
  "lifecycle.editor.relation.onboarding.before": "before the first day",
  "lifecycle.editor.relation.onboarding.on": "on the first day",
  "lifecycle.editor.relation.onboarding.after": "after the first day",
  "lifecycle.editor.relation.offboarding.before": "before the last day",
  "lifecycle.editor.relation.offboarding.on": "on the last day",
  "lifecycle.editor.relation.offboarding.after": "after the last day",
  "lifecycle.editor.daysRange": "Up to 90 days before or 180 days after.",
  "lifecycle.editor.moveUp": "Move task {number} up",
  "lifecycle.editor.moveDown": "Move task {number} down",
  "lifecycle.editor.remove": "Remove task {number}",
  "lifecycle.editor.moved": "{title} moved to place {position} of {total}.",
  "lifecycle.editor.untitled": "Untitled task",
  "lifecycle.editor.addTask": "Add a task",
  "lifecycle.editor.save": "Save template",
  "lifecycle.editor.saved": "{name} saved.",
  "lifecycle.category.laptop": "Laptop",
  "lifecycle.category.phone": "Phone",
  "lifecycle.category.tablet": "Tablet",
  "lifecycle.category.monitor": "Monitor",
  "lifecycle.category.key_card": "Key card",
  "lifecycle.category.other": "Other",
  "lifecycle.assetStatus.available": "Available",
  "lifecycle.assetStatus.assigned": "Handed over",
  "lifecycle.assetStatus.maintenance": "In maintenance",
  "lifecycle.assetStatus.retired": "Retired",
  "lifecycle.register.title": "Asset register",
  "lifecycle.register.description": "Every device and card the agency hands out, who has it and since when.",
  "lifecycle.register.caption": "Asset register",
  "lifecycle.register.add": "Add an asset",
  "lifecycle.register.editNamed": "Edit {title}",
  "lifecycle.register.loadError": "We could not load the asset register",
  "lifecycle.register.empty.title": "The register is empty",
  "lifecycle.register.empty.body": "Add the laptops, phones and key cards the agency hands out, then record who holds each one.",
  "lifecycle.register.statusFilter": "Filter by status",
  "lifecycle.register.all": "All",
  "lifecycle.register.categoryFilter": "Filter by category",
  "lifecycle.register.allCategories": "All categories",
  "lifecycle.register.search": "Search assets",
  "lifecycle.register.noMatch.title": "Nothing matches",
  "lifecycle.register.noMatch.body": "Try another search, or clear the filters.",
  "lifecycle.register.clear": "Clear filters",
  "lifecycle.register.columns.name": "Asset",
  "lifecycle.register.columns.category": "Category",
  "lifecycle.register.columns.serial": "Serial number",
  "lifecycle.register.columns.status": "Status",
  "lifecycle.register.columns.holder": "Held by",
  "lifecycle.register.columns.since": "Since",
  "lifecycle.register.columns.actions": "Actions",
  "lifecycle.assetForm.name": "Name",
  "lifecycle.assetForm.namePlaceholder": "MacBook Pro 14",
  "lifecycle.assetForm.nameMissing": "Give the asset a name.",
  "lifecycle.assetForm.category": "Category",
  "lifecycle.assetForm.customCategory": "Something else…",
  "lifecycle.assetForm.customLabel": "Which category",
  "lifecycle.assetForm.customPlaceholder": "Camera",
  "lifecycle.assetForm.categoryMissing": "Name the category.",
  "lifecycle.assetForm.serial": "Serial number",
  "lifecycle.assetForm.purchasedOn": "Bought on",
  "lifecycle.assetForm.status": "Status",
  "lifecycle.assetForm.assignedNote": "It is with {name}. Take it back first to change its status.",
  "lifecycle.assetForm.notes": "Notes",
  "lifecycle.assetForm.create": "Add asset",
  "lifecycle.assetForm.save": "Save changes",
  "lifecycle.assetForm.added": "{title} added to the register.",
  "lifecycle.assetForm.saved": "{title} saved.",
  "lifecycle.handover.open": "Hand over an asset",
  "lifecycle.handover.short": "Hand over",
  "lifecycle.handover.openFor": "Hand over {title}",
  "lifecycle.handover.titleAsset": "Hand over {title}",
  "lifecycle.handover.titlePerson": "Hand an asset over to {name}",
  "lifecycle.handover.asset": "Asset",
  "lifecycle.handover.assetPlaceholder": "Choose an available asset",
  "lifecycle.handover.assetMissing": "Choose the asset.",
  "lifecycle.handover.noneAvailable": "No asset is available right now. Add one to the register, or take one back first.",
  "lifecycle.handover.person": "Handed to",
  "lifecycle.handover.personMissing": "Choose who receives it.",
  "lifecycle.handover.on": "Handed over on",
  "lifecycle.handover.condition": "Condition when handed over",
  "lifecycle.handover.conditionHint": "Optional. Scratches, accessories included, anything to check on return.",
  "lifecycle.handover.submit": "Hand over",
  "lifecycle.handover.done": "{title} handed over to {name}.",
  "lifecycle.giveBack.open": "Take back",
  "lifecycle.giveBack.openFor": "Take back {title}",
  "lifecycle.giveBack.title": "Take back {title}",
  "lifecycle.giveBack.since": "{name} has had it since {date}.",
  "lifecycle.giveBack.holder": "It is with {name}.",
  "lifecycle.giveBack.on": "Returned on",
  "lifecycle.giveBack.condition": "Condition when returned",
  "lifecycle.giveBack.conditionHint": "Optional. Note any damage or missing parts.",
  "lifecycle.giveBack.submit": "Take back",
  "lifecycle.giveBack.done": "{title} is back and available.",
  "lifecycle.assets.heldTitle": "Assets they hold",
  "lifecycle.assets.heldDescription": "What {name} has from the agency, and since when.",
  "lifecycle.assets.heldBy": "Assets held by {name}",
  "lifecycle.assets.loadError": "We could not load their assets",
  "lifecycle.assets.heldEmpty.title": "Nothing handed over",
  "lifecycle.assets.heldEmpty.body": "{name} holds no asset of the agency.",
  "lifecycle.assets.since": "Since {date}",
  "lifecycle.leaver.leaving": "{name}’s last day is {date}",
  "lifecycle.leaver.left": "{name} left on {date}",
  "lifecycle.leaver.stillHeld": "{count, plural, one {# asset is} other {# assets are}} still with them. Take them back before the final settlement.",
  "lifecycle.leaver.allBack": "Every asset is back.",
  "lifecycle.leaver.settlement": "Final settlement",
  "lifecycle.letterStatus.pending": "Waiting",
  "lifecycle.letterStatus.approved": "Issued",
  "lifecycle.letterStatus.rejected": "Turned down",
  "lifecycle.letterStatus.cancelled": "Withdrawn",
  "lifecycle.language.ar": "Arabic",
  "lifecycle.language.en": "English",
  "lifecycle.letters.title": "Letter requests",
  "lifecycle.letters.description": "Every letter people asked for. Decisions usually happen in Requests; open a letter to read or print it.",
  "lifecycle.letters.caption": "Letter requests",
  "lifecycle.letters.loadError": "We could not load the letter requests",
  "lifecycle.letters.empty.title": "No letter requests yet",
  "lifecycle.letters.empty.body": "When someone asks for an employment certificate or an experience letter from My HR, it shows here.",
  "lifecycle.letters.statusFilter": "Filter by status",
  "lifecycle.letters.search": "Search by person or letter",
  "lifecycle.letters.noMatch": "No letter matches",
  "lifecycle.letters.columns.letter": "Letter",
  "lifecycle.letters.columns.employee": "Employee",
  "lifecycle.letters.columns.addressee": "Addressed to",
  "lifecycle.letters.columns.requested": "Asked on",
  "lifecycle.letters.columns.status": "Status",
  "lifecycle.letters.toWhom": "whom it may concern",
  "lifecycle.letter.toWhomLabel": "To whom it may concern",
  "lifecycle.letter.back": "All letters",
  "lifecycle.letter.loadError": "We could not load this letter",
  "lifecycle.letter.missing.title": "This letter is not here",
  "lifecycle.letter.missing.body": "It may have been removed, or the link is wrong.",
  "lifecycle.letter.requestTitle": "Request",
  "lifecycle.letter.employee": "Employee",
  "lifecycle.letter.language": "Language",
  "lifecycle.letter.addressee": "Addressed to",
  "lifecycle.letter.purpose": "Purpose",
  "lifecycle.letter.requested": "Asked on",
  "lifecycle.letter.print": "Print",
  "lifecycle.letter.copy": "Copy text",
  "lifecycle.notIssued.title.pending": "Waiting for approval",
  "lifecycle.notIssued.title.rejected": "Turned down",
  "lifecycle.notIssued.title.cancelled": "Withdrawn",
  "lifecycle.notIssued.body.pending": "The letter appears here, ready to print, once it is approved.",
  "lifecycle.notIssued.body.rejected": "This letter will not be issued.",
  "lifecycle.notIssued.body.cancelled": "The request was withdrawn, so no letter was issued.",
  "lifecycle.notIssued.waitingOn": "Waiting for {name} to approve.",
  "lifecycle.notIssued.waitingOnHr": "Waiting for HR to approve.",
  "lifecycle.flow.title": "Approvals",
  "lifecycle.flow.label": "Approval steps",
  "lifecycle.flow.requested": "Requested",
  "lifecycle.flow.withdrawn": "Withdrawn",
  "lifecycle.flow.role.manager": "Manager",
  "lifecycle.flow.role.hr": "HR",
  "lifecycle.flow.state.waiting": "Not yet",
  "lifecycle.flow.state.current": "Deciding now",
  "lifecycle.flow.state.approved": "Approved",
  "lifecycle.flow.state.rejected": "Turned down",
  "lifecycle.flow.state.skipped": "Not needed",
  "lifecycle.flow.decided.approved": "Approved by {name} · {when}",
  "lifecycle.flow.decided.rejected": "Turned down by {name} · {when}",
  "lifecycle.decision.title": "Your decision",
  "lifecycle.decision.description": "This request waits on you.",
  "lifecycle.decision.approve": "Approve",
  "lifecycle.decision.reject": "Turn down",
  "lifecycle.decision.approveTitle": "Approve {name}’s letter?",
  "lifecycle.decision.approveBody": "If yours is the last approval, the letter is issued with today’s details from the record and cannot be changed afterwards.",
  "lifecycle.decision.rejectTitle": "Turn down {name}’s letter?",
  "lifecycle.decision.rejectBody": "Say why. They see your reason with the request.",
  "lifecycle.decision.issued": "Approved. The letter is issued.",
  "lifecycle.decision.passed": "Approved. It moves on to the next step.",
  "lifecycle.decision.rejected": "Request turned down.",
  "lifecycle.withdraw.open": "Withdraw",
  "lifecycle.withdraw.openFor": "Withdraw the request for {title}",
  "lifecycle.withdraw.title": "Withdraw the request for {title}?",
  "lifecycle.withdraw.body": "It stops waiting for approval. You can ask again any time.",
  "lifecycle.withdraw.confirm": "Withdraw request",
  "lifecycle.withdraw.pending": "Withdrawing…",
  "lifecycle.withdraw.done": "Request withdrawn.",
  "lifecycle.ask.open": "Ask for a letter",
  "lifecycle.ask.title": "Ask for a letter",
  "lifecycle.ask.description": "Your manager approves it, then HR. Once issued it is here, ready to print. Letters never show your pay.",
  "lifecycle.ask.template": "Letter",
  "lifecycle.ask.language": "Language",
  "lifecycle.ask.addressee": "Addressed to",
  "lifecycle.ask.addresseeHint": "Leave it empty for “To whom it may concern”.",
  "lifecycle.ask.addresseePlaceholder": "Banque Misr",
  "lifecycle.ask.purpose": "What is it for?",
  "lifecycle.ask.purposeHint": "Optional. A bank account, a visa, a course…",
  "lifecycle.ask.submit": "Send the request",
  "lifecycle.ask.sent": "Request sent. The letter appears here once it is approved.",
  "lifecycle.ask.templatesError": "We could not load the letters you can ask for. Try again in a moment.",
  "lifecycle.ask.noTemplates": "HR has not set up any letters yet.",
  "lifecycle.me.title": "Letters & assets",
  "lifecycle.me.back": "My letters",
  "lifecycle.me.tasksTitle": "Waiting for you",
  "lifecycle.me.tasksDescription": "Tasks from a colleague’s onboarding or offboarding that are yours to do.",
  "lifecycle.me.tasksError": "We could not load your checklist tasks",
  "lifecycle.me.lettersTitle": "My letters",
  "lifecycle.me.lettersDescription": "Employment certificates and experience letters you asked HR for.",
  "lifecycle.me.lettersError": "We could not load your letters",
  "lifecycle.me.lettersEmpty.title": "No letters yet",
  "lifecycle.me.lettersEmpty.body": "Need a certificate for a bank or an embassy? Ask HR for it here.",
  "lifecycle.me.letterMeta": "{label} · asked {date}",
  "lifecycle.me.openLetter": "Open the letter",
  "lifecycle.me.openLetterFor": "Open the letter: {title}",
  "lifecycle.me.assetsTitle": "My assets",
  "lifecycle.me.assetsDescription": "What the agency has handed you.",
  "lifecycle.me.assetsError": "We could not load your assets",
  "lifecycle.me.assetsEmpty": "Nothing is handed over to you.",
  "lifecycle.letterTemplates.title": "Letter templates",
  "lifecycle.letterTemplates.description": "The letters people may ask for, written once in Arabic and English.",
  "lifecycle.letterTemplates.new": "New letter",
  "lifecycle.letterTemplates.loadError": "We could not load the letter templates",
  "lifecycle.letterTemplates.empty.title": "No letter templates yet",
  "lifecycle.letterTemplates.empty.body": "Write an employment certificate or an experience letter once; people then ask for it from My HR.",
  "lifecycle.letterEditor.newTitle": "New letter template",
  "lifecycle.letterEditor.editTitle": "Edit letter template",
  "lifecycle.letterEditor.nameAr": "Name in Arabic",
  "lifecycle.letterEditor.nameEn": "Name in English",
  "lifecycle.letterEditor.nameMissing": "Give it a name in this language.",
  "lifecycle.letterEditor.active": "People may ask for it",
  "lifecycle.letterEditor.activeHint": "Letters already issued stay as they are either way.",
  "lifecycle.letterEditor.noPayTitle": "Letters never show pay",
  "lifecycle.letterEditor.noPayBody": "Salary and allowances are not placeholders, so no letter can reveal them.",
  "lifecycle.letterEditor.bodyLanguage": "Letter text",
  "lifecycle.letterEditor.body.ar": "Arabic text",
  "lifecycle.letterEditor.body.en": "English text",
  "lifecycle.letterEditor.bodyMissing": "Write the letter in this language too.",
  "lifecycle.letterEditor.placeholders": "Insert a detail from the record",
  "lifecycle.letterEditor.insert": "Insert {label}",
  "lifecycle.letterEditor.unknownTitle": "These placeholders are not filled in and will print as typed:",
  "lifecycle.letterEditor.preview": "Preview",
  "lifecycle.letterEditor.previewHint": "Preview with a sample person’s details",
  "lifecycle.letterEditor.untitled": "Untitled letter",
  "lifecycle.letterEditor.save": "Save letter",
  "lifecycle.letterEditor.saved": "Letter template saved.",
  "lifecycle.placeholder.name": "Name",
  "lifecycle.placeholder.employee_code": "Employee code",
  "lifecycle.placeholder.title": "Job title",
  "lifecycle.placeholder.department": "Department",
  "lifecycle.placeholder.hire_date": "Hire date",
  "lifecycle.placeholder.contract_type": "Contract type",
  "lifecycle.placeholder.addressee": "Addressee",
  "lifecycle.placeholder.today": "Today’s date",
  "lifecycle.sample.name": "Mona Adel",
  "lifecycle.sample.title": "Senior designer",
  "lifecycle.sample.department": "Design",
  "lifecycle.paper.date": "Date",
  "lifecycle.paper.department": "Human Resources",
  "lifecycle.paper.signedFor": "For 404 Creative",
  "lifecycle.paper.signature": "Signature and stamp",
  "lifecycle.errors.serialTaken": "Another asset already has this serial number.",
  "lifecycle.errors.assetUnavailable": "This asset is with someone else, in maintenance or retired.",
  "lifecycle.errors.assetNotFound": "We could not find that asset. It may have been removed.",
  "lifecycle.errors.checklistNotFound": "We could not find that checklist, or the task is not yours to tick.",
  "lifecycle.errors.templateNotFound": "We could not find that template. It may have been removed.",
  "lifecycle.errors.letterTemplateNotFound": "That letter is no longer offered.",
  "lifecycle.errors.letterNotFound": "We could not find that letter request.",
  "lifecycle.errors.noRecord": "There is no HR record for this person yet. HR has to open one first.",
  "lifecycle.errors.requestClosed": "This request was already decided or withdrawn.",
  "lifecycle.errors.notYourDecision": "This step waits on someone else."
}
